function directive($http) {
    return {
        link: function ($scope, element) {
            $scope.$on('forceChart', function (event, data) {
                var width = $("#forcechart").parent().width(),
                    height = width/1.5;

                var value_offset = 120;
                var tCount = [];
                data.links.forEach(function (d) {
                    tCount.push(d.value);
                });
                var maxNum = Math.max.apply(Math, tCount);
                var palette = {
                    "lightgray": "#819090",
                    "gray": "#708284",
                    "mediumgray": "#536870",
                    "darkgray": "#3a3a3a",
                    "darkblue": "#0A2933",
                    "darkerblue": "#042029",
                    "paleryellow": "#FCF4DC",
                    "paleyellow": "#EAE3CB",
                    "yellow": "#A57706",
                    "orange": "#BD3613",
                    "red": "#D11C24",
                    "pink": "#C61C6F",
                    "purple": "#595AB7",
                    "blue": "#2176C7",
                    "green": "#259286",
                    "yellowgreen": "#738A05"
                };
                var count = function (size) {
                    if (size === undefined) {
                        size = 1;
                    }
                    return size;
                };

                function logslider(x) {
                    if (x === undefined) {
                        return 110;
                    }
                    // position will be between 0 and 100
                    // if (x > 50) {
                    //  x = appendInfo50;
                    // }
                    var minp = 0;
                    var maxp = maxNum;
                    // the result should be between 100 an 10000000
                    var minv = Math.log(5);
                    var maxv = Math.log(40);
                    // calculate adjustment factor
                    var scale = (maxv-minv) / (maxp-minp);
                    return Math.exp(minv + scale*(x-minp));
                }

                // define the zoomListener which calls the zoom function on the "zoom" event constrained within the scaleExtents
                var zoomListener = d3.behavior.zoom().scaleExtent([0.7, 3]).on("zoom", zoom);

                var outVis = d3.select("#forcechart").append('svg')
                    .attr("width", width)
                    .attr("height", height)
                    .call(zoomListener);
                var vis = outVis
                    .append("svg")
                    .attr("class", "stage")
                    .append("g");

                function zoom() {
                    vis.attr("transform", "translate(" + d3.event.translate + ")scale(" + d3.event.scale + ")");
                }

                var force = d3.layout.force()
                    .nodes(data.nodes)
                    .links(data.links)
                    .gravity(function (d) {
                        if (d.class === 'child') {
                           return  0.2;
                        } else {
                           return  0;
                        }
                    })
                    .linkDistance(function (d) {
                        if (d.class === 'child') {
                            return  130;
                        } else {
                            var w;
                            if (width/2 > 400) {
                                w = 400;
                            } else {
                                w = width/2;
                            }
                            return w;
                        }
                    })
                    .charge(-30)
                    .size([width-50, height]);

                var link = vis.selectAll(".link")
                    .data(data.links)
                    .enter().append('g')
                    .attr('class', 'linkgroup')
                    .append("line")
                    .attr("class", "link")
                    .style("display", function (d) {
                         if (d.allowed==="authorized") {
                            return 'none';
                        } else {
                            return 'inline-block';
                        }
                    })
                    .style('stroke', function (d) {
                        if (d.class === 'child') {
                            if (d.allowed==="authorized") {
                                return '#00FF00';
                            } else {
                                return '#CC0000';
                            }
                        } else {
                            return '#259286';
                        }
                    })
                    .style('stroke-opacity', function (d) {
                        if (d.class === 'child') {
                            return '.7';
                        } else {
                            return '1';
                        }
                    })
                    .attr('stroke-width', function (d) {
                        if (d.class === 'child') {
                            return '3';
                        } else {
                            return '50';
                        }
                    });

                var node_drag = d3.behavior.drag()
                    .on("dragstart", dragstart)
                    .on("drag", dragmove)
                    .on("dragend", dragend);

                var node = vis.selectAll("circle.node")
                    .data(data.nodes)
                    .enter().append("g")
                    .attr("class", "node")
                    .call(node_drag);
                    //.call(force.drag);

                let draggin = false;
                function dragstart(d) {
                    d3.event.sourceEvent.stopPropagation();
                    d.fixed = true;
                    force.stop();
                    draggin = false;
                }

                function dragmove(d) {
                    draggin = true;
                    d.px += d3.event.dx;
                    if ((d.px >= value_offset) && (d.px <= width-value_offset)) {
                        d.x += d3.event.dx;
                    }
                    d.py += d3.event.dy;
                    if ((d.py >= value_offset) && (d.py <= height-value_offset)) {
                        d.y += d3.event.dy;
                    }
                    tick();
                }

                function dragend(d) {
                    if (draggin) {
                        d.fixed = true;
                        d.px = d.x;
                        d.py = d.y;
                        $scope.page.save_coordinates(d);
                    }
                    tick();
                    force.resume();
                }

                var infoDiv = d3.select('#forcechartinfo').append('table');

                node.each(function (d) {
                    var elm = d3.select(this).append('g').attr('transform', 'scale(0.7)');
                    if (d.group === 'child') {
                    } else {
                        d.fixed = true;
                    }
                    switch (d.group) {
                        case 'coi':
                            // CIRCLE
                            elm.append('svg:circle')
                                .attr('r', function (d) {
                                    return logslider(d["width"]);
                                })
                                .attr('fill', '#fff')
                                .style('stroke-width', "14px")
                                .style('stroke', function (d) {
                                    if (d.name === 'QuarantineCOI') {
                                        return '#ff0000';
                                    } else {
                                        return '#259286';
                                    }
                                });

                            // TEXT appends name
                            elm.append("text")
                                .text(function (d) { return d.name; })
                                .on('mouseover', function () {
                                    d3.select(this).style('cursor', 'pointer')
                                })
                                .on('click', function (d) {
                                    $scope.requery(d, 'blocked');
                                })
                                .attr("x", 0)
                                .attr("y", 10)
                                .attr("font-family",  "Helvetica Neue, Arial")
                                .attr("fill", '#c61c6f')
                                .style("font-size", '2em')
                                .attr("text-anchor", 'middle');

                            // TEXT appends count
                            var text = elm.append("g")
                                .attr('transform', 'translate(0, 90)')

                            text.append('text')
                                .html(function (d) { return d.count; })
                                .attr("fill", '#000')
                                .style("font-size", '4em')
                                .attr("text-anchor", 'middle');

                            // append a rectangle on top for click events
                            text.append('rect')
                                .attr('x', -34)
                                .attr('y', -45)
                                .style('fill-opacity', '0.4')
                                .style('fill', '#fff')
                                .attr('width', 70)
                                .attr('height', 50)
                                .on('mouseover', function () {
                                    d3.select(this).style('cursor', 'pointer')
                                    .style('fill-opacity', '0');
                                })
                                .on('click', function (d) {
                                    $scope.requery(d, 'users');
                                })
                                .on('mouseout', function () {
                                    d3.select(this)
                                    .style('fill-opacity', '0.4');
                                });

                            // ICONS
                            // right button red x
                            // elm.append('g')
                            //     .attr('transform', 'scale(.8)')
                            //     .append('g')
                            //     .attr('transform', 'translate(113, -15)')
                            //     .append('path')
                            //     .attr('d', 'M0,29.9c0-0.6,11.3-12,11.8-12.6c0.5-0.5-3.3-13-3.3-14.6C8.4,1.5,10.7,0,11.2,0'+
                            //     'c2.1,0,9.4,9.1,9.4,9.1s11-8.2,12.3-7.8c2.5,0.8,3.5,3,2,4.4c-2.3,2.5-11,11.8-11,13.9c0,1,5.3,8.7,4.7,9.5l-3.1,4.5'+
                            //     'c-0.6,0.9-10-7.7-10-7.7S5.3,35.8,4.9,35.8C4.5,35.8,0,30.5,0,29.9z')
                            //     .attr('style', 'fill:#f60000;fill-opacity:1;stroke:none;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1');

                            // elm.append("svg:circle")
                            //     .attr("cx", 92)
                            //     .attr("cy", 0)
                            //     .attr("r", 24)
                            //     .attr("fill", '#fff')
                            //     .style('fill-opacity', '0.3')
                            //     .on('mouseover', function () {
                            //         d3.select(this).style('cursor', 'pointer')
                            //         .style('fill-opacity', '0');
                            //     })
                            //     .on('click', function (d) {
                            //         $scope.requery(d, 'blocked');
                            //     })
                            //     .on('mouseout', function () {d3.select(this)
                            //     .style('fill-opacity', '0.3');
                            //     });

                            // // left button check mark
                            // elm.append('g')
                            //     .attr('transform', 'scale(.9)')
                            //     .append('g')
                            //     .attr('transform', 'translate(-315,-525)')
                            //     .append('path')
                            //         .style('fill', '#000000')
                            //         .attr('d', 'M193.6,542.1c-0.5,0-8.8-14.6-8.8-14.6l8-3.6l1.6,8.4c0,0,19.9-22.3,21.7-23.9l4.3-0.2'+
                            //         'C220.3,508.2,194.1,542.1,193.6,542.1z')
                            //     .on('mouseover', function () {
                            //         d3.select(this).style('cursor', 'pointer');
                            //     })
                            //     .on('click', function (d) {
                            //         $scope.requery(d, 'right');
                            //     });

                            // elm.append("svg:circle")
                            //     .attr("cx", -90)
                            //     .attr("cy", 0)
                            //     .attr("r", 24)
                            //     .attr("fill", '#fff')
                            //     .style('fill-opacity', '0.3')
                            //     .on('mouseover', function () {
                            //         d3.select(this).style('cursor', 'pointer')
                            //         .style('fill-opacity', '0');
                            //     })
                            //     .on('click', function (d) {
                            //         $scope.requery(d, 'authorized');
                            //     })
                            //     .on('mouseout', function () {d3.select(this)
                            //     .style('fill-opacity', '0.3');
                            //     });

                            switch (d.name) {
                                case 'ClearTextCOI':
                                    elm.append('path')
                                        .style('fill', palette.gray)
                                        .attr('d', 'M36.8,12.2L19.6,15l4.4-12L36.8,0V12.2z M3.8,20.8l9.2-3.7l5.4-11.4L3.8,20.8z M36.8,16.5l-18.6,3.8'+
                                        'L17.5,37h19.3V16.5z M12.2,21.6l-9.8,3.6L0,37h10.3L12.2,21.6z M42.8,12.2L59.9,15l-4.6-12L42.8,0V12.2z M60.4,5.8l5.4,11.4l9.2,3.7'+
                                        'L60.4,5.8z M42.8,37h20.4L61,20.3l-18.2-3.8V37z M68.6,37h10.3l-2.4-11.8l-9.8-3.6L68.6,37z M36.8,67.2l-17.3-2.8l4.4,12l12.8,3.1'+
                                        'V67.2z M18.5,73.6l-5.4-11.4l-9.2-3.7L18.5,73.6z M36.8,42H17.5l0.7,16.8l18.6,2.1V42z M10.3,42H0l2.4,11.9l9.8,3.7L10.3,42z'+
                                        ' M42.8,79.4l12.4-3.1l4.6-12l-17.1,2.8V79.4z M75.1,58.6l-9.2,3.7l-5.4,11.4L75.1,58.6z M42.8,60.9L61,58.8L63.2,42H42.8V60.9z'+
                                        ' M66.7,57.5l9.8-3.7L78.9,42H68.6L66.7,57.5z')
                                        .attr('transform', 'translate(-25,-95) scale(0.7)');

                                    elm.append("svg:circle")
                                        .attr("cx", 2)
                                        .attr("cy", -60)
                                        .attr("r", 32)
                                        .attr("fill", '#fff')
                                        .style('fill-opacity', '0.3')
                                        .on('mouseover', function () {
                                            d3.select(this).style('cursor', 'pointer')
                                            .style('fill-opacity', '0');
                                        })
                                        .on('click', function (d) {
                                            $scope.requery(d, 'rules');
                                        })
                                        .on('mouseout', function () {
                                            d3.select(this)
                                            .style('fill-opacity', '0.3');
                                        });
                                    break;
                                case 'QuarantineCOI':
                                    elm.append('path')
                                        .style('fill', '#ff0000')
                                        .attr('d','M36.6,32.1c1.4-2.2,2.4-4.7,2.9-7.3c-8.1-3.3-13.8-11.2-13.8-20.5c0-1.1,0.1-2.1,0.2-3.1 C23.7,0.4,21.3,0,18.8,0c-0.2,0-0.4,0-0.6,0'+
                                        'c-0.2,1.4-0.3,2.9-0.3,4.3C17.9,16.9,25.6,27.7,36.6,32.1z M94.3,36.2c-4.3,5-10.6,8.1-17.7,8.1c-12.9,0-23.4-10.4-23.4-23.3c0-3.8,0.9-7.5,2.6-10.7'+
                                        'l-2.8-1.6 c-1.2,1.4-3.1,2.4-5.1,2.4c-2.1,0-3.9-0.9-5.1-2.4l-3,1.8c1.6,3.2,2.5,6.8,2.5,10.6c0,12.9-10.5,23.3-23.4,23.3 c-7,0-13.3-3.1-17.6-7.9'+
                                        'L0,37.1c6.2,8,15.9,13.1,26.7,13.1c8,0,15.3-2.8,21.1-7.4c5.8,4.6,13.1,7.4,21.1,7.4 c10.9,0,20.6-5.2,26.7-13.1L94.3,36.2z')
                                        .attr('transform', 'translate(-21,-70) scale(0.5)');

                                    elm.append('path')
                                        .style('fill', '#ff0000')
                                        .attr('d','M36.6,32.1c1.4-2.2,2.4-4.7,2.9-7.3c-8.1-3.3-13.8-11.2-13.8-20.5c0-1.1,0.1-2.1,0.2-3.1 C23.7,0.4,21.3,0,18.8,0c-0.2,0-0.4,0-0.6,0'+
                                        'c-0.2,1.4-0.3,2.9-0.3,4.3C17.9,16.9,25.6,27.7,36.6,32.1z M94.3,36.2c-4.3,5-10.6,8.1-17.7,8.1c-12.9,0-23.4-10.4-23.4-23.3c0-3.8,0.9-7.5,2.6-10.7'+
                                        'l-2.8-1.6 c-1.2,1.4-3.1,2.4-5.1,2.4c-2.1,0-3.9-0.9-5.1-2.4l-3,1.8c1.6,3.2,2.5,6.8,2.5,10.6c0,12.9-10.5,23.3-23.4,23.3 c-7,0-13.3-3.1-17.6-7.9'+
                                        'L0,37.1c6.2,8,15.9,13.1,26.7,13.1c8,0,15.3-2.8,21.1-7.4c5.8,4.6,13.1,7.4,21.1,7.4 c10.9,0,20.6-5.2,26.7-13.1L94.3,36.2z')
                                        .attr('transform', 'rotate(120,33,-39) scale(0.5)');

                                    elm.append('path')
                                        .style('fill', '#ff0000')
                                        .attr('d','M36.6,32.1c1.4-2.2,2.4-4.7,2.9-7.3c-8.1-3.3-13.8-11.2-13.8-20.5c0-1.1,0.1-2.1,0.2-3.1 C23.7,0.4,21.3,0,18.8,0c-0.2,0-0.4,0-0.6,0'+
                                        'c-0.2,1.4-0.3,2.9-0.3,4.3C17.9,16.9,25.6,27.7,36.6,32.1z M94.3,36.2c-4.3,5-10.6,8.1-17.7,8.1c-12.9,0-23.4-10.4-23.4-23.3c0-3.8,0.9-7.5,2.6-10.7'+
                                        'l-2.8-1.6 c-1.2,1.4-3.1,2.4-5.1,2.4c-2.1,0-3.9-0.9-5.1-2.4l-3,1.8c1.6,3.2,2.5,6.8,2.5,10.6c0,12.9-10.5,23.3-23.4,23.3 c-7,0-13.3-3.1-17.6-7.9'+
                                        'L0,37.1c6.2,8,15.9,13.1,26.7,13.1c8,0,15.3-2.8,21.1-7.4c5.8,4.6,13.1,7.4,21.1,7.4 c10.9,0,20.6-5.2,26.7-13.1L94.3,36.2z')
                                        .attr('transform', 'rotate(240,-6.5,-27) scale(0.5)');

                                    elm.append("svg:circle")
                                        .attr("cx", 2)
                                        .attr("cy", -60)
                                        .attr("r", 32)
                                        .attr("fill", '#fff')
                                        .style('fill-opacity', '0.3')
                                        .on('mouseover', function () {
                                            d3.select(this).style('cursor', 'pointer')
                                            .style('fill-opacity', '0');
                                        })
                                        .on('click', function (d) {
                                           $scope.requery(d, 'rules');
                                        })
                                        .on('mouseout', function () {
                                            d3.select(this)
                                            .style('fill-opacity', '0.3');
                                        });
                                    break;
                                default:
                                    elm.append('polygon')
                                        .style('fill', '#515151')
                                        .attr('points', '53,18 53,10 60,10 60,0 44,0 44,10 51,10 51,16 31,16 31,10 38,10 38,0 22,0 22,10 29,10 '+
                                        '29,16 9,16 9,10 16,10 16,0 0,0 0,10 7,10 7,18 29,18 29,26 7,26 7,35 0,35 0,45 16,45 16,35 9,35 9,28 29,28 29,35 22,35 22,45 '+
                                        '38,45 38,35 31,35 31,28 51,28 51,35 44,35 44,45 60,45 60,35 53,35 53,26 31,26 31,18 ')
                                        .attr('transform', 'translate(-25,-90) scale(0.9)');

                                    elm.append("svg:circle")
                                        .attr("cx", 2)
                                        .attr("cy", -60)
                                        .attr("r", 40)
                                        .attr("fill", '#fff')
                                        .style('fill-opacity', '0.3')
                                        .on('mouseover', function () {
                                            d3.select(this).style('cursor', 'pointer')
                                            .style('fill-opacity', '0');
                                        })
                                        .on('click', function (d) {
                                            $scope.requery(d, 'rules');
                                        })
                                        .on('mouseout', function () {
                                            d3.select(this)
                                            .style('fill-opacity', '0.3');
                                        });
                                    break;
                            }
                        break;
                        case 'child':
                            if (d.value.type === 'Stealth COI Mismatch') {
                                elm.append("path")
                                    .attr('d', 'M14,3.1C9.4,3.3,7,0,7,0c0,0-2,3.1-7,3.1C-0.4,8.3,2.7,18,7,18C11.2,18,14.4,7.2,14,3.1z')
                                    .attr('transform', 'translate(-25,-115) scale(0.7)')
                                    .style('fill', "#000")
                                    .style('border', "solid 1px #000")
                                    .attr('transform', 'translate(-8,-8) scale(1.1)')
                            } else if (d.value.type === 'Stealth COI Mismatch v3') {
                                elm.append("path")
                                    .attr('d', 'M14,3.1C9.4,3.3,7,0,7,0c0,0-2,3.1-7,3.1C-0.4,8.3,2.7,18,7,18C11.2,18,14.4,7.2,14,3.1z')
                                    .attr('transform', 'translate(-25,-115) scale(0.7)')
                                    .style('fill', "#666")
                                    .style('border', "solid 1px #666")
                                    .attr('transform', 'translate(-8,-8) scale(1.1)')
                            } else if (d.value.type === 'Non-Stealth Internal Attack') {
                                elm.append('rect')
                                    .attr('x', function (d) { return d.x; })
                                    .attr('y', function (d) { return d.y; })
                                    .attr('height', 14)
                                    .attr('width', 14)
                                    .style('fill', "#002E7F")
                                    .attr('transform', 'translate(-8,-8)')
                                    .style('fill-opacity', '1')
                            } else if (d.value.type === 'outside') {
                                elm.append("circle")
                                    .attr("cx", function (d) { return d.x; })
                                    .attr("cy", function (d) { return d.y; })
                                    .attr("r", 8)
                                    .attr("fill", "#000")
                                    .style('border', "solid 1px #000")
                            } else {
                                elm.append("path")
                                    .attr('d', 'M14,3.1C9.4,3.3,7,0,7,0c0,0-2,3.1-7,3.1C-0.4,8.3,2.7,18,7,18C11.2,18,14.4,7.2,14,3.1z')
                                    .attr('transform', 'translate(-25,-115) scale(0.7)')
                                    .style('fill', "#000")
                                    .style('border', "solid 1px #000")
                                    .attr('transform', 'translate(-8,-8) scale(1.1)')
                            }
                        break;
                    }
                });

                $scope.appendInfo = function (data, type) {
                    infoDiv.selectAll('tr').remove();
                    var divInfo = '';
                    if (type === "linkBetween") {
                        var uniqueNodes = $scope.forcedata.uniqueNodes;
                        var uniqueUsers = $scope.forcedata.uniqueUsers;
                        var unique = [];
                        var source = data.source.name;
                        var target = data.target.name;

                        for (var i in uniqueNodes[source]) {
                            for (var j in uniqueNodes[target]) {
                                if (i === j) {
                                    unique.push(i);
                                }
                            }
                        }
                        for (var x=0; x<unique.length; x++) {
                            divInfo = '';
                            divInfo += '<div><strong>'+unique[x]+': </strong>';
                            for (var k in uniqueUsers) {
                                if (k === unique[x]) {
                                    for (var z=0; z<Object.keys(uniqueUsers[k]).length; z++) {
                                        divInfo += Object.keys(uniqueUsers[k])[z];
                                        if (z < Object.keys(uniqueUsers[k]).length-1) {
                                            divInfo += ", ";
                                        }
                                    }
                                }
                            }
                            divInfo +='</div>';
                            var row = infoDiv.append('tr');
                            row
                                .append('td')
                                .html(divInfo);
                        }
                    } else if (type === "rules") {
                            divInfo += '<div><strong>Rules: </strong><br />';
                            var rules = "";
                            for (var i = 0; i < data.rules.length; i++) {
                                if (data.rules[i].rule !== "-") {
                                    var ruleString = data.rules[i].rule.replace(/Except/g , "<br />Except");
                                    divInfo += data.rules[i].order  + "<br />" + " " + ruleString + "<br />";
                                } else {
                                    divInfo += "none <br />";
                                }
                            }
                            var row = infoDiv.append('tr');
                                row
                                    .append('td')
                                    .html(divInfo);
                    } else {
                        for (var i in data) {
                            if (typeof data[i] === 'object') {
                                divInfo = "";
                                for (var e in data[i]) {
                                    divInfo += '<div><strong>'+e+': </strong>'+data[i][e]+'</div>';
                                }
                                var row = infoDiv.append('tr');
                                    row
                                        .append('td')
                                        .html(divInfo);
                            } else {
                                var row = infoDiv.append('tr');
                                    row
                                        .append('td')
                                        .html('<strong>'+dictionary(i)+'</strong>');
                                    row
                                        .append('td')
                                        .text(data[i]);
                            }
                        }
                    }
                };

                $scope.pageLoadInfo = function (data) {
                    for (var i in data) {
                        if (typeof data[i] === 'object') {
                            var divInfo = '';
                            for (var e in data[i]) {
                                if (e !==  "index") {
                                    divInfo += '<div><strong>'+e+': </strong>'+data[i][e]+'</div>';
                                }
                            }
                            var row = infoDiv.append('tr');
                                row
                                    .append('td')
                                    .html(divInfo);
                        } else {
                            var row = infoDiv.append('tr');
                                row
                                    .append('td')
                                    .html('<strong>'+dictionary(i)+'</strong>');
                                row
                                    .append('td')
                                    .text(data[i]);
                        }
                    }
                };

                var linktext = d3.selectAll('.linkgroup');
                var text = linktext
                    .append('text')
                    .attr("fill", '#fff')
                    .style('font-size', '2.5em')
                    .style('cursor', 'pointer')
                    .attr('text-anchor', 'middle')
                    .text(function (d) { return d.value; })
                    .on('click', function (d) {
                        $scope.appendInfo(d, 'linkBetween');
                    });

                function tick() {
                    node[0].x = width;
                    node[0].y = height;

                    node.attr("cx", function (d) {
                            if (d.group === "child") {
                                value_offset = 0;
                            } else {
                                value_offset = 120;
                            }
                            return d.x = Math.max(value_offset, Math.min(width - value_offset, d.x));
                        })
                        .attr("cy", function (d) {
                            if (d.group === "child") {
                                value_offset = 0;
                            } else {
                                value_offset = 120;
                            }
                            return d.y = Math.max(value_offset, Math.min(height - value_offset, d.y)); });

                    link.attr("x1", function (d) { return d.source.x; })
                        .attr("y1", function (d) { return d.source.y; })
                        .attr("x2", function (d) { return d.target.x; })
                        .attr("y2", function (d) { return d.target.y; });

                    text.attr("transform", function (d) {
                        var x1 = d.source.x;
                        var x2 = d.target.x;
                        var y1 = d.source.y;
                        var y2 = d.target.y;
                        var x = (x1+x2)/2;
                        var y = ((y1+y2)*1.027)/2;
                        return "translate(" + x + "," + y + ")";
                    });

                    node.attr("transform", function (d) {
                        return "translate(" + d.x + "," + d.y + ")";
                    });
                }
                force.on("tick", tick);
                force.start();
                $scope.onloadInfo();

                function isColor(data) {
                    if ((data === "Stealth COIs") || ( data === "User with Shared Access")) {
                        return "#259286";
                    } else if ((data === "Stealth COIs") || ( data === "User with Shared Access")) {
                        return "#1F5E76";
                    }
                    return "#1F5E76";
                }

                // LEGEND
                var standard_legend = outVis.selectAll(".standard_legend")
                    .data(["Standard"])
                    .enter().append("g")
                    .attr("class", "standard_legend")
                    .attr("transform", function (d, i) { return "translate(0," + i * 30 + ")"; });
                standard_legend.append('svg:polygon')
                    .attr('transform', 'translate(0,0) scale(0.5)')
                    .style('fill', palette.gray)
                    .attr('points', '53,18 53,10 60,10 60,0 44,0 44,10 51,10 51,16 31,16 31,10 38,10 38,0 22,0 22,10 29,10 '+
                    '29,16 9,16 9,10 16,10 16,0 0,0 0,10 7,10 7,18 29,18 29,26 7,26 7,35 0,35 0,45 16,45 16,35 9,35 9,28 29,28 29,35 22,35 22,45 '+
                    '38,45 38,35 31,35 31,28 51,28 51,35 44,35 44,45 60,45 60,35 53,35 53,26 31,26 31,18');
                standard_legend.append("text")
                    .attr("x", 38)
                    .attr("y", 13)
                    .attr("dy", ".35em")
                    .text(function (d) { return d; });

                // var ct_legend = outVis.selectAll(".ct_legend")
                //     .data(["ClearText"])
                //     .enter().append("g")
                //     .attr("class", "ct_legend")
                //     .attr("transform", function (d, i) { return "translate(0," + i * 30 + ")"; });
                // ct_legend.append('svg:path')
                //     .attr('transform', 'translate(0,30) scale(0.4)')
                //     .style('fill', palette.gray)
                //     .attr('d', 'M36.8,12.2L19.6,15l4.4-12L36.8,0V12.2z M3.8,20.8l9.2-3.7l5.4-11.4L3.8,20.8z M36.8,16.5l-18.6,3.8'+
                //     'L17.5,37h19.3V16.5z M12.2,21.6l-9.8,3.6L0,37h10.3L12.2,21.6z M42.8,12.2L59.9,15l-4.6-12L42.8,0V12.2z M60.4,5.8l5.4,11.4l9.2,3.7'+
                //     'L60.4,5.8z M42.8,37h20.4L61,20.3l-18.2-3.8V37z M68.6,37h10.3l-2.4-11.8l-9.8-3.6L68.6,37z M36.8,67.2l-17.3-2.8l4.4,12l12.8,3.1'+
                //     'V67.2z M18.5,73.6l-5.4-11.4l-9.2-3.7L18.5,73.6z M36.8,42H17.5l0.7,16.8l18.6,2.1V42z M10.3,42H0l2.4,11.9l9.8,3.7L10.3,42z'+
                //     ' M42.8,79.4l12.4-3.1l4.6-12l-17.1,2.8V79.4z M75.1,58.6l-9.2,3.7l-5.4,11.4L75.1,58.6z M42.8,60.9L61,58.8L63.2,42H42.8V60.9z'+
                //     ' M66.7,57.5l9.8-3.7L78.9,42H68.6L66.7,57.5z');
                // ct_legend.append("text")
                //     .attr("x", 38)
                //     .attr("y", 47)
                //     .attr("dy", ".35em")
                //     .text(function (d) { return d; });

                var quar_legend = outVis.selectAll(".quar_legend")
                    .data(["Quarantine"])
                    .enter().append("g")
                    .attr("class", "quar_legend")
                    .attr("transform", function (d, i) { return "translate(0, -37)"; });
                quar_legend.append('svg:path')
                    .attr('transform', 'translate(5,82) scale(0.25)')
                    .style('fill', '#ff0000')
                    .attr('d', 'M36.6,32.1c1.4-2.2,2.4-4.7,2.9-7.3c-8.1-3.3-13.8-11.2-13.8-20.5c0-1.1,0.1-2.1,0.2-3.1 C23.7,0.4,21.3,0,18.8,0c-0.2,0-0.4,0-0.6,0'+
                    'c-0.2,1.4-0.3,2.9-0.3,4.3C17.9,16.9,25.6,27.7,36.6,32.1z M94.3,36.2c-4.3,5-10.6,8.1-17.7,8.1c-12.9,0-23.4-10.4-23.4-23.3c0-3.8,0.9-7.5,2.6-10.7'+
                    'l-2.8-1.6 c-1.2,1.4-3.1,2.4-5.1,2.4c-2.1,0-3.9-0.9-5.1-2.4l-3,1.8c1.6,3.2,2.5,6.8,2.5,10.6c0,12.9-10.5,23.3-23.4,23.3 c-7,0-13.3-3.1-17.6-7.9'+
                    'L0,37.1c6.2,8,15.9,13.1,26.7,13.1c8,0,15.3-2.8,21.1-7.4c5.8,4.6,13.1,7.4,21.1,7.4 c10.9,0,20.6-5.2,26.7-13.1L94.3,36.2z');
                quar_legend.append('svg:path')
                    .attr('transform', 'rotate(120,-9.25,43.25) scale(0.25)')
                    .style('fill', '#ff0000')
                    .attr('d', 'M36.6,32.1c1.4-2.2,2.4-4.7,2.9-7.3c-8.1-3.3-13.8-11.2-13.8-20.5c0-1.1,0.1-2.1,0.2-3.1 C23.7,0.4,21.3,0,18.8,0c-0.2,0-0.4,0-0.6,0'+
                    'c-0.2,1.4-0.3,2.9-0.3,4.3C17.9,16.9,25.6,27.7,36.6,32.1z M94.3,36.2c-4.3,5-10.6,8.1-17.7,8.1c-12.9,0-23.4-10.4-23.4-23.3c0-3.8,0.9-7.5,2.6-10.7'+
                    'l-2.8-1.6 c-1.2,1.4-3.1,2.4-5.1,2.4c-2.1,0-3.9-0.9-5.1-2.4l-3,1.8c1.6,3.2,2.5,6.8,2.5,10.6c0,12.9-10.5,23.3-23.4,23.3 c-7,0-13.3-3.1-17.6-7.9'+
                    'L0,37.1c6.2,8,15.9,13.1,26.7,13.1c8,0,15.3-2.8,21.1-7.4c5.8,4.6,13.1,7.4,21.1,7.4 c10.9,0,20.6-5.2,26.7-13.1L94.3,36.2z');
                quar_legend.append('svg:path')
                    .attr('transform', 'rotate(240,38,40.5) scale(0.25)')
                    .style('fill', '#ff0000')
                    .attr('d', 'M36.6,32.1c1.4-2.2,2.4-4.7,2.9-7.3c-8.1-3.3-13.8-11.2-13.8-20.5c0-1.1,0.1-2.1,0.2-3.1 C23.7,0.4,21.3,0,18.8,0c-0.2,0-0.4,0-0.6,0'+
                    'c-0.2,1.4-0.3,2.9-0.3,4.3C17.9,16.9,25.6,27.7,36.6,32.1z M94.3,36.2c-4.3,5-10.6,8.1-17.7,8.1c-12.9,0-23.4-10.4-23.4-23.3c0-3.8,0.9-7.5,2.6-10.7'+
                    'l-2.8-1.6 c-1.2,1.4-3.1,2.4-5.1,2.4c-2.1,0-3.9-0.9-5.1-2.4l-3,1.8c1.6,3.2,2.5,6.8,2.5,10.6c0,12.9-10.5,23.3-23.4,23.3 c-7,0-13.3-3.1-17.6-7.9'+
                    'L0,37.1c6.2,8,15.9,13.1,26.7,13.1c8,0,15.3-2.8,21.1-7.4c5.8,4.6,13.1,7.4,21.1,7.4 c10.9,0,20.6-5.2,26.7-13.1L94.3,36.2z');
                quar_legend.append("text")
                    .attr("x", 38)
                    .attr("y", 81)
                    .attr("dy", ".35em")
                    .text(function (d) { return d; });

                // var checkmark_legend = outVis.selectAll(".checkmark_legend")
                //     .data(["Allowed Connections"])
                //     .enter().append("g")
                //     .attr("class", "checkmark_legend")
                //     .attr("transform", function (d, i) { return "translate(0," + i * 30 + ")"; });
                // checkmark_legend
                //     .append('svg:path')
                //     .attr('transform', 'translate(-85, -150) scale(0.5)')
                //     .attr('d', 'M193.6,542.1c-0.5,0-8.8-14.6-8.8-14.6l8-3.6l1.6,8.4c0,0,19.9-22.3,21.7-23.9l4.3-0.2'+
                //     'C220.3,508.2,194.1,542.1,193.6,542.1z')
                //     .style('fill', '#000000');
                // checkmark_legend.append("text")
                //     .attr("x", 38)
                //     .attr("y", 112)
                //     .attr("dy", ".35em")
                //     .text(function (d) { return d; });

                // var redx_legend = outVis.selectAll(".redx_legend")
                //     .data(["Dropped Connections"])
                //     .enter().append("g")
                //         .attr("class", "redx_legend")
                //         .attr("transform", function (d, i) { return "translate(0," + i * 30 + ")"; });
                // redx_legend.append('svg:path')
                //     .attr('transform', 'translate(7,130) scale(0.5)')
                //     .attr('d', 'M0,29.9c0-0.6,11.3-12,11.8-12.6c0.5-0.5-3.3-13-3.3-14.6C8.4,1.5,10.7,0,11.2,0'+
                //     'c2.1,0,9.4,9.1,9.4,9.1s11-8.2,12.3-7.8c2.5,0.8,3.5,3,2,4.4c-2.3,2.5-11,11.8-11,13.9c0,1,5.3,8.7,4.7,9.5l-3.1,4.5'+
                //     'c-0.6,0.9-10-7.7-10-7.7S5.3,35.8,4.9,35.8C4.5,35.8,0,30.5,0,29.9z')
                //     .attr('style', 'fill:#f60000;fill-opacity:1;stroke:none;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1');
                // redx_legend.append("text")
                    // .attr("x", 38)
                    // .attr("y", 139)
                    // .attr("dy", ".35em")
                    // .text(function (d) { return d; });

                var nameCirlcle = [];
                var nameLink = [];
                nameCirlcle.push("Stealth COIs");
                nameLink.push("User with Shared Access");

                var circle_legend = outVis.selectAll(".circle_legend")
                    .data(nameCirlcle)
                    .enter().append("g")
                    .attr("class", "circle_legend")
                    .attr("transform", function (d, i) { return "translate(0, -39)"; });
                circle_legend.append('svg:circle')
                    .attr('transform', 'translate(15,119) scale(0.5)')
                    .attr('r', 25)
                    .style('fill', '#fff')
                    .style("stroke-width", "8px")
                    .style("stroke" , function (d) { return isColor(d) });
                circle_legend.append("text")
                    .attr("x", 38)
                    .attr("y", 119)
                    .attr("dy", ".35em")
                    .text(function (d) { return d; });

                var link_legend = outVis.selectAll(".link_legend")
                    .data(nameLink)
                    .enter().append("g")
                    .attr("class", "link_legend")
                    .attr("transform", function (d, i) { return "translate(0, -36)"; });
                link_legend.append('svg:rect')
                    .attr('transform', 'translate(0,'+ (139) +')')
                    .style('fill', function (d) { return isColor(d) })
                    .attr('width', 30)
                    .attr('height', 20);
                link_legend.append("text")
                    .attr("x", 38)
                    .attr("y", (149))
                    .attr("dy", ".35em")
                    .text(function (d) { return d; });

                $scope.$on('$destroy', function () {
                    element.remove();
                });
            })
        }
    };
}

directive.$inject = ['$http'];
module.exports = directive;


/** WEBPACK FOOTER **
 ** ./src/pages/directives/coichart/makecoichart.js
 **/